import { Alert, Button, Col, DatePicker, Form, Input, InputNumber, Row, Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import PageTitle from "../page-header/PageHeader";

//Update customer API REQ
const updateCustomer = async (id, values) => {
  try {
    await axios({
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `customer/${id}`,
      data: {
        ...values,
      },
    });
    return "success";
    // return data;
  } catch (error) {
    console.log(error.message);
  }
};

function UpdateCust() {
  const { Title } = Typography;
  const [form] = Form.useForm();
  const [success, setSuccess] = useState(false);
  const { id } = useParams();

  //Loading Old data from URL
  const location = useLocation();
  const { data } = location.state;

  const cust = data;
  const [initValues, setInitValues] = useState({
    name: cust.name,
    phone: cust.phone,
    address: cust.address,
    due_amount: cust.due_amount,
    opening_balance: cust.opening_balance ?? 0,
    opening_balance_date: cust.opening_balance_date ? moment(cust.opening_balance_date) : null,
  });

  const onFinish = (values) => {
    try {
      const payload = {
        ...values,
        opening_balance: values.opening_balance != null ? values.opening_balance : 0,
        opening_balance_date: values.opening_balance_date ? values.opening_balance_date.format("YYYY-MM-DD") : undefined,
      };
      updateCustomer(id, payload);
      setSuccess(true);
      toast.success("Customer details is updated");
      setInitValues({});
    } catch (error) {
      console.log(error.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/auth/login"} replace={true} />;
  }

  return (
    <>
      <Title
        title={`Update Customer/ ${id}`}
        subtitle="Update customer information"
      />
      <div className="text-center">
        <div className="">
          <Row className="mr-top">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={14}
              className="border rounded column-design"
            >
              {success && (
                <div>
                  <Alert
                    message={`customer details updated successfully`}
                    type="success"
                    closable={true}
                    showIcon
                  />
                </div>
              )}
              <Title level={3} className="m-3 text-center">
                Edit Customer Form
              </Title>
              <Form
                initialValues={{
                  ...initValues,
                }}
                form={form}
                className="m-4"
                name="basic"
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  fields={[{ name: "Name" }]}
                  label="Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input customer name!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Phone"
                  name="phone"
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Address"
                  name="address"
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Due Amount"
                  name="due_amount"
                  rules={[
                    {
                      type: Number,
                      required: true,
                      message: "Please input customer amount!",
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Opening Balance"
                  name="opening_balance"
                >
                  <InputNumber min={0} style={{ width: "100%" }} placeholder="0" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label={
                    <span>
                      Date
                      <Tooltip title="Opening Balance Date">
                        <InfoCircleOutlined style={{ marginLeft: 4, color: "#999", cursor: "help" }} />
                      </Tooltip>
                    </span>
                  }
                  name="opening_balance_date"
                >
                  <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  wrapperCol={{
                    offset: 0,
                    span: 24,
                  }}
                >
                  <Button
                    block
                    type="primary"
                    htmlType="submit"
                    shape="round"
                    style={{
                      marginBottom: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Update Now
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default UpdateCust;
